import styled from 'styled-components';

export const ContentWrapper = styled.div<{ layout: boolean }>`
  display: flex;
  flex-direction: ${(props) => (props.layout ? 'column' : 'row')};
  margin: 7px;
  flex: 1;
  height: ${(props) => (props.layout ? 'auto' : '100%')};
`;

export const MetricsPanelWrapper = styled.div`
  width: 380px;
  margin-right: 2px;
  height: 100%;
  margin-bottom: 0;
`;

export const HzMetricsPanelWrapper = styled.div`
  width: 100%;
`;

export const DimensionPanelWrapper = styled.div<{ layout: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  flex-shrink: ${(props) => (props.layout ? 0 : 1)};
  flex-basis: fit-content;
  overflow: hidden;

  &:hover {
    overflow: hidden auto;
  }
`;
